import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import moment from 'moment'
import '../../../assets/stylesheets/gallery-style.css'
import '../../../assets/stylesheets/assets.css'
import '../../../assets/stylesheets/duplicates.css'
import '../../../assets/stylesheets/modal.css'
import { ModalContainer } from '../Modal'
import upArrow from '../../../assets/images/up-arrow.png'
import backArrow from '../../../assets/images/back-arrow3.png'
import homeIcon from '../../../assets/images/home-icon.png'
import { useSearch } from '../hooks/useSearch'

/**
 * SearchResults Component
 *
 * Displays search results in a gallery format with navigation controls
 * Extracted from Header/searchedAssets.js
 */
export const SearchResults = () => {
  const searchParams = new URLSearchParams(window.location.search)
  const searchTerm = searchParams.get('term') || ''
  const navigate = useNavigate()
  const userId = localStorage.getItem('username')

  const {
    isLoading,
    state,
    dispatch,
    handleAssetClick,
    closeModal,
    loadMoreResults,
    performSearch
  } = useSearch()

  // Perform search when component mounts or search term changes
  useEffect(() => {
    if (!searchTerm || !userId) return
    performSearch(searchTerm, userId)
  }, [searchTerm, userId, performSearch])

  // Navigation functions
  const goBack = () => navigate(-1)
  const goHome = () => navigate('/gallery')
  const scrollTop = () => window.scrollTo({ top: 0, behavior: 'smooth' })

  // Loading state
  if (isLoading) {
    return <div>Loading…</div>
  }

  const published = Object.values(state.publishedAssets)
  const visibleAssets = published.slice(
    0,
    state.loading.currentPage * state.loading.pageSize
  )

  // No results state
  if (!published.length) {
    return (
      <div className="duplicates-category-container">
        <div className="go-back">
          <img
            className="nav-icon-home home fav"
            src={homeIcon}
            alt="Home"
            onClick={goHome}
          />
          <img
            className="nav-icon-back back"
            alt="Back"
            src={backArrow}
            onClick={goBack}
          />
          <img
            className="nav-icon-top top"
            alt="Top"
            src={upArrow}
            onClick={scrollTop}
          />
        </div>
        <div className="no-results-message">
          Sorry, no results found for "<strong>{searchTerm}</strong>".
        </div>
      </div>
    )
  }

  // Results display
  return (
    <div className="duplicates-category-container">
      <div className="go-back">
        <img
          className="nav-icon-home home fav"
          src={homeIcon}
          alt="Home"
          onClick={goHome}
        />
        <img
          className="nav-icon-back back"
          alt="Back"
          src={backArrow}
          onClick={goBack}
        />
        <img
          className="nav-icon-top top"
          alt="Top"
          src={upArrow}
          onClick={scrollTop}
        />
      </div>

      <h2 className="row-title-duplicates">
        Search Results for "{searchTerm}"
      </h2>

      <div className="gallery-container">
        {visibleAssets.map(asset => (
          <div key={asset.id} className="gallery-thumb-duplicates">
            <div
              className="gallery-thumb2"
              style={{
                backgroundImage: asset.src || asset.thumbnailUrl || asset.thumbnail || asset.s3uri ? `url('${asset.src || asset.thumbnailUrl || asset.thumbnail || asset.s3uri}')` : 'none',
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center center',
                backgroundColor: asset.src ? 'transparent' : 'var(--light)'
              }}
              onClick={() => handleAssetClick(asset.id)}
            >
              <div className="duplicates-date">
                {moment(asset.content?.date).format('DD MMMM YYYY')}
              </div>
            </div>
          </div>
        ))}
        {visibleAssets.length < published.length && (
          <div className="load-more-container">
            <button
              className="ui active button load-more-btn-search"
              onClick={loadMoreResults}
            >
              Load More
            </button>
          </div>
        )}
      </div>

      {state.modalActive && (
        <ModalContainer
          state={state}
          dispatch={dispatch}
          onClose={closeModal}
          props={{ state, dispatch }}
        />
      )}
    </div>
  )
}
